import { DadosDespausarType } from "../types";

export function mapperDadosDespausar(data: string): DadosDespausarType {
  const dadosObj = data
    .trim()
    .split(";")
    .reduce(
      (a, c, i) => ({
        ...a,
        [["idUsuario", "idGrupo", "idRetorno", "descRetorno"][i]]: c,
      }),
      {}
    );

  return dadosObj as DadosDespausarType;
}
